var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightShadeSmall = function SvgArrowRightShadeSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.98 3.48a.5.5 0 0 1 .707 0l4.167 4.166a.5.5 0 0 1 0 .707L9.687 12.52a.5.5 0 1 1-.707-.707L12.293 8.5H2.5a.5.5 0 0 1 0-1h9.793L8.98 4.187a.5.5 0 0 1 0-.707",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRightShadeSmall;